import React from 'react'
import PropTypes from 'prop-types' 
import './style.css'

class InputAuthCode extends React.Component {
  constructor(props) {
    super(props)

    let { length, value, type} = props
    let boxes = []
    length = Number(length)
    if (length > 32) length = 32
    for (let i = 0; i < length; i += 1) { 
      const v = value[i] || ''
      boxes.push(v);
    }
    this.state = {
      value,
      length,
      type,
      boxes,
    }
    this.textInput = []
  }
  componentDidMount() {
    !!this.props.autoFocus && this.textInput[0] && this.textInput[0].focus()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      let boxes = []
      for (let i = 0; i < this.state.length; i += 1) { 
        const v = this.props.value[i] || ''
        boxes.push(v);
      }
      this.setState({boxes})
    }
  }

  onChange = (e, h) => { 
    const ignoreChars = ['-','.']
    let value = String(e.currentTarget.value)
    // Will have to change code if Mixed Alpha Numeric is allowed for pasting
    if (e.target.type ==='number') {
      value = value.replace(/[^\d]/g, '')
    } else {
      value = value.toUpperCase()
    }
    value = value.split('').filter(c => {return !ignoreChars.includes(c)}).join('')

    if (value !== '') {
      let { boxes, length } = this.state

      const current = Number(e.currentTarget.dataset.index)
      if (value.length>1) { // Paste
        value.split('').map((b,i) => { 
          if (current+i < length) boxes[current+i] = b
          return false
        })
      } else {
        boxes[current] = value
      }

      boxes.map((s, i) => {
        if (this.textInput[i]) {
          this.textInput[i].value = s
        }
        return false
      })

      let next = current + value.length
      if (next >= length) next = length-1
      const newTarget = this.textInput[next]
      newTarget.focus()
      newTarget.select()

      value = boxes.join('')
      this.setState({ value, boxes })
    }
    
    if (this.props.onChange) this.props.onChange(value)
  }

  onKeyDown = (e, h) => { 
    const current = Number(e.currentTarget.dataset.index)
    const prev = current - 1
    const next = current + 1

    // Up, Down, E, -, . 
    const ignoreCodes= [38, 40, 189, 190] 
    ignoreCodes.map((item) => {
      if (item === e.keyCode) {
        e.preventDefault() 
        return true 
      }
    }) 
    
    switch (e.keyCode) {
      case 8: // Backspace
        e.preventDefault()
        this.textInput[current].value = ''
        let { boxes, value } = this.state
        boxes[current] = ''
        value = boxes.join('')

        this.setState({ value, boxes })
        if (prev >= 0) {
          const newTarget = this.textInput[prev]
          newTarget.focus()
          newTarget.select()
        }
        if (this.props.onChange) this.props.onChange(value) 
        break
      case 13: // Enter Key SENT!
        e.preventDefault()
        if (next < this.textInput.length) {
          const newTarget = this.textInput[next]
          newTarget.focus()
          newTarget.select()
        } else {
          this.props.onEnter()
        }
        break
      case 37: // Left Arrow
        e.preventDefault()
        if (prev >= 0) {
          const newTarget = this.textInput[prev]
          newTarget.focus()
          newTarget.select()
        }
        break
      case 39: // Right Arrow
        e.preventDefault()
        if (next < this.textInput.length) {
          const newTarget = this.textInput[next]
          newTarget.focus()
          newTarget.select()
        }
        break
      case 69: // E Key Ignore on Number ('E'xponent)
        if (e.target.type ==='number') e.preventDefault()
        break
      default:
        break
    }
  }
  onFocus = (e) => e.target.select(e) 

  render() {
    const { name, placeholder, disabled, /* width, fluid, */ className, style } = this.props 
    const { length, boxes, type } = this.state
    return (
      <div className='input-auth-code' style={{style}}>
      {
        boxes.map((value,i) =>{
          return (<input disabled={disabled}
            ref={(ref) => {
              this.textInput[i] = ref
            }}
            key={`${name}_${i}`}
            data-index={i}
            type={type}
            value={ value }
            min={0}
            max={9}
            maxLength={1}
            className={className}
            onFocus={this.onFocus}
            /* onBlur={this.onBlur} */
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
          /*  disabled={disabled} */
            placeholder={placeholder}/>
        )})
      }
      </div>
    )
  }
}


InputAuthCode.defaultProps = {
  length: 6,
  type: 'number',
  disabled: false,
}

InputAuthCode.propTypes = {
  name: PropTypes.string.isRequired,  
  onChange: PropTypes.func.isRequired 
}

export default InputAuthCode